import Actions from "./Actions";
const initialState = {
  isAppDoneAutoLoginProcess: false
};
function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case Actions.SET_APP_LOGIN_STATE:
      return { isAppDoneAutoLoginProcess: payload };
    default:
      return state;
  }
}

export function getIsAppDoneAutoLoginState(state) {
  return state.isAppDoneAutoLoginProcess;
}

export default reducer;
